import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CheckBoxModule, NumericTextBoxModule, RadioButtonModule, SwitchModule } from '@progress/kendo-angular-inputs';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { PopupModule } from '@progress/kendo-angular-popup';
import { CompartilhadoModule } from '../compartilhado/compartilhado.module';
import { TelaCatalogoProdutosV2Component } from './tela-catalogo-produtos-v2/tela-catalogo-produtos-v2.component';
import { TelaEditorProdutoV2Component } from './tela-editor-produto-v2/tela-editor-produto-v2.component';
import { TelaEditorAdicionalV2Component } from './tela-editor-adicional-v2/tela-editor-adicional-v2.component';
import { TelaTabelaPrecosV2Component } from './tela-tabela-precos-v2/tela-tabela-precos-v2.component';
import { TelaImportadorCardapioIaComponent } from './tela-importador-cardapio-ia/tela-importador-cardapio-ia.component';
import { TelaCatalogoAdicionaisV2Component } from './tela-catalogo-adicionais-v2/tela-catalogo-adicionais-v2.component';
import { TelaEditorAdicionalGlobalV2Component } from './tela-editor-adicional-global-v2/tela-editor-adicional-global-v2.component';

@NgModule({
  declarations: [
    TelaCatalogoProdutosV2Component,
    TelaEditorProdutoV2Component,
    TelaEditorAdicionalV2Component,
    TelaTabelaPrecosV2Component,
    TelaImportadorCardapioIaComponent,
    TelaCatalogoAdicionaisV2Component,
    TelaEditorAdicionalGlobalV2Component
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    DragDropModule,
    CheckBoxModule,
    NumericTextBoxModule,
    RadioButtonModule,
    SwitchModule,
    DialogModule,
    DropDownsModule,
    PopupModule,
    CompartilhadoModule
  ],
  exports: [
    TelaTabelaPrecosV2Component
  ]
})
export class ProdutosV2Module {}
